var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStamp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "450px",
    height: "220px",
    viewBox: "27 150 130 20",
    id: "svg11816",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs11813"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14252"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#074e9c",
      strokeWidth: 0.567816,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect294183-6-2",
    width: 81.679405,
    height: 47.646175,
    x: 51.615826,
    y: 139.66969
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0413\\u041E\\u0421\\u0423\\u0414\\u0410\\u0420\\u0421\\u0422\\u0412\\u0415\\u041D\\u041D\\u041E\\u0415 \\u0423\\u0427\\u0420\\u0415\\u0416\\u0415\\u041D\\u0418\\u0415 \\u0423\\u041F\\u0420\\u0410\\u0412\\u041B\\u0415\\u041D\\u0418\\u042F \\u0417\\u0414\\u0420\\u0410\\u0412\\u041E\\u041E\\u0425\\u0420\\u0410\\u041D\\u0415\\u041D\\u0418\\u042F \\u0420\\u041E\\u0421\\u0421\\u0418\\u0419\\u0421\\u041A\\u041E\\u0419 \\u0424\\u0415\\u0414\\u0415\\u0420\\u0410\\u0426\\u0418\\u0418 \\u0413. \\u041A\\u0420\\u0410\\u0421\\u041D\\u041E\\u0414\\u0410\\u0420 \"\\u0413\\u041E\\u0420\\u041E\\u0414\\u0421\\u041A\\u0410\\u042F \\u041F\\u041E\\u041B\\u0418\\u041A\\u041B\\u0418\\u041D\\u0418\\u041A\\u0410 \\u211600\" ",
    transform: "scale(1.0094153,0.99067252)",
    id: "text297325-5-7",
    style: {
      fontSize: "5.06957px",
      lineHeight: 0,
      display: "inline",
      fill: "#074e9c",
      strokeWidth: 0.190108
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 60.837285,143.67956 h 0.463266 v 3.41923 h -0.463266 z m 0.268083,0 h 1.293381 v 0.43975 h -1.293381 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.734008,147.13406 q -0.310412,0 -0.540868,-0.12699 -0.230457,-0.12934 -0.355092,-0.3645 -0.122284,-0.23751 -0.122284,-0.55968 v -1.38744 q 0,-0.32217 0.122284,-0.55968 0.124635,-0.23751 0.355092,-0.3645 0.230456,-0.12699 0.540868,-0.12699 0.310411,0 0.540868,0.12699 0.230457,0.12699 0.352741,0.3645 0.124634,0.23751 0.124634,0.55968 v 1.38744 q 0,0.32217 -0.124634,0.55968 -0.122284,0.23516 -0.352741,0.3645 -0.230457,0.12699 -0.540868,0.12699 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0706 0.124634,-0.0705 0.190479,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41566 q 0,-0.17872 -0.0682,-0.31041 -0.06585,-0.13169 -0.190479,-0.20224 -0.124635,-0.0705 -0.291599,-0.0705 -0.166964,0 -0.291599,0.0705 -0.124635,0.0705 -0.192831,0.20224 -0.06585,0.13169 -0.06585,0.31041 v 1.41566 q 0,0.17872 0.06585,0.31041 0.0682,0.13169 0.192831,0.20224 0.124635,0.0706 0.291599,0.0706 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.228607,147.13406 q -0.301005,0 -0.524407,-0.12934 -0.221051,-0.12934 -0.340983,-0.3692 -0.119931,-0.24222 -0.119931,-0.56909 v -1.35217 q 0,-0.32922 0.119931,-0.56909 0.119932,-0.24221 0.340983,-0.37155 0.223402,-0.12934 0.524407,-0.12934 0.291598,0 0.503243,0.11758 0.211644,0.11758 0.331575,0.34569 0.122284,0.2281 0.143448,0.55498 v 0 h -0.47032 v 0 q -0.01646,-0.18108 -0.08231,-0.30806 -0.06584,-0.12699 -0.17637,-0.19284 -0.108174,-0.0658 -0.24927,-0.0658 -0.157557,0 -0.272786,0.0753 -0.115228,0.0752 -0.178722,0.214 -0.06349,0.13874 -0.06349,0.32922 v 1.35217 q 0,0.18813 0.06349,0.32923 0.06349,0.13874 0.178722,0.21399 0.115229,0.0729 0.272786,0.0729 0.141096,0 0.24927,-0.0635 0.110525,-0.0635 0.17637,-0.19048 0.06584,-0.12699 0.08231,-0.31276 v 0 h 0.47032 v 0 q -0.02116,0.32687 -0.143448,0.55497 -0.119931,0.22811 -0.331575,0.34569 -0.211645,0.11758 -0.503243,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 67.559163,143.67956 h 0.507946 l 0.736051,2.50916 -0.298653,0.38331 z m 1.434477,2.77253 q -0.0682,0.22811 -0.174019,0.37861 -0.10347,0.15051 -0.253973,0.22811 -0.150502,0.0753 -0.355092,0.0753 h -0.298653 v -0.45856 h 0.298653 q 0.101119,0 0.178722,-0.047 0.0776,-0.047 0.134041,-0.1364 0.05879,-0.0894 0.09642,-0.22575 l 0.705481,-2.58676 h 0.48443 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 69.661044,146.65904 h 0.03998 q 0.223403,0 0.345686,-0.20224 0.122283,-0.20224 0.122283,-0.56909 v -2.20815 h 0.463266 v 2.25048 q 0,0.32452 -0.105822,0.55498 -0.103471,0.23045 -0.301005,0.35274 -0.197535,0.11993 -0.477375,0.11993 h -0.08701 z m -0.03527,0 h 0.463266 v 1.14758 H 69.62577 Z m 0,0 h 2.443314 v 0.43975 H 69.62577 Z m 2.23167,0 h 0.463266 v 1.14758 H 71.85744 Z m -0.39742,-2.97948 h 0.463265 v 3.41923 H 71.46002 Z m -0.992376,0 h 1.206371 v 0.43975 h -1.206371 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.688887,143.67956 h 0.409179 l 1.015892,3.41923 h -0.49854 l -0.721942,-2.73727 -0.724293,2.73727 h -0.496188 z m -0.475024,2.23402 h 1.389797 v 0.4374 h -1.389797 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.769604,145.33273 h 0.863038 q 0.122284,0 0.211644,-0.0564 0.09171,-0.0564 0.141096,-0.16226 0.04938,-0.10582 0.04938,-0.24691 v -0.27279 q 0,-0.1458 -0.04938,-0.25162 -0.04938,-0.10818 -0.141096,-0.16461 -0.08936,-0.0588 -0.211644,-0.0588 h -0.863038 v -0.43975 h 0.848929 q 0.272785,0 0.472672,0.11052 0.202237,0.11053 0.308059,0.31747 0.108174,0.20459 0.108174,0.48208 v 0.28219 q 0,0.27749 -0.108174,0.47973 -0.108173,0.20223 -0.308059,0.31276 -0.199887,0.10817 -0.472672,0.10817 h -0.848929 z m -0.246918,-1.65317 h 0.463266 v 3.41923 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.962629,147.13406 q -0.301005,0 -0.524407,-0.12934 -0.221051,-0.12934 -0.340982,-0.3692 -0.119932,-0.24222 -0.119932,-0.56909 v -1.35217 q 0,-0.32922 0.119932,-0.56909 0.119931,-0.24221 0.340982,-0.37155 0.223402,-0.12934 0.524407,-0.12934 0.291599,0 0.503243,0.11758 0.211644,0.11758 0.331576,0.34569 0.122283,0.2281 0.143447,0.55498 v 0 h -0.47032 v 0 q -0.01646,-0.18108 -0.08231,-0.30806 -0.06584,-0.12699 -0.17637,-0.19284 -0.108174,-0.0658 -0.24927,-0.0658 -0.157557,0 -0.272786,0.0753 -0.115228,0.0752 -0.178722,0.214 -0.06349,0.13874 -0.06349,0.32922 v 1.35217 q 0,0.18813 0.06349,0.32923 0.06349,0.13874 0.178722,0.21399 0.115229,0.0729 0.272786,0.0729 0.141096,0 0.24927,-0.0635 0.110525,-0.0635 0.17637,-0.19048 0.06585,-0.12699 0.08231,-0.31276 v 0 h 0.47032 v 0 q -0.02116,0.32687 -0.143447,0.55497 -0.119932,0.22811 -0.331576,0.34569 -0.211644,0.11758 -0.503243,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13549"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.921063,143.9594 h 0.463266 v 3.13939 h -0.463266 z m -0.780732,-0.27984 h 2.022378 v 0.43975 h -2.022378 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.841871,146.66609 h 0.738402 q 0.251622,0 0.376257,-0.10582 0.124635,-0.10582 0.124635,-0.29865 v -0.23752 q 0,-0.1505 -0.05174,-0.25632 -0.05173,-0.10817 -0.152854,-0.16461 -0.101119,-0.0588 -0.251621,-0.0588 h -0.783083 v -0.42799 h 0.783083 q 0.199886,0 0.305708,-0.10818 0.105822,-0.11052 0.105822,-0.31982 v -0.18107 q 0,-0.19518 -0.112877,-0.29395 -0.112877,-0.10112 -0.329224,-0.10112 h -0.752512 v -0.43269 h 0.790138 q 0.282192,0 0.477375,0.0964 0.195183,0.0941 0.291598,0.27514 0.09877,0.17872 0.09877,0.42799 v 0.19048 q 0,0.16696 -0.05879,0.30571 -0.05879,0.13874 -0.178722,0.23281 -0.11758,0.0941 -0.286895,0.12698 0.17637,0.0259 0.305708,0.12464 0.129338,0.0988 0.195183,0.25162 0.0682,0.1505 0.0682,0.33863 v 0.23751 q 0,0.24927 -0.10347,0.4327 -0.101119,0.18342 -0.296302,0.28219 -0.195183,0.0964 -0.458562,0.0964 h -0.844225 z m -0.282193,-2.98653 h 0.463266 v 3.41923 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 85.10366,143.67956 h 0.463265 v 3.41923 H 85.10366 Z m 0.232808,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.399203 v 0.4374 h -1.399203 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 88.952781,143.67956 h 0.463266 v 3.41923 h -0.463266 z m -1.519135,0 h 0.465618 v 3.41923 h -0.465618 z m 0.298654,1.51678 h 1.457993 v 0.4374 H 87.7323 Z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 91.588478,143.67956 h 0.463265 v 3.41923 h -0.463265 z m -1.519135,0 h 0.465617 v 3.41923 h -0.465617 z m 0.298653,1.51678 h 1.457993 v 0.4374 h -1.457993 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 93.690358,147.13406 q -0.310411,0 -0.540868,-0.12699 -0.230457,-0.12934 -0.355092,-0.3645 -0.122283,-0.23751 -0.122283,-0.55968 v -1.38744 q 0,-0.32217 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.3645 0.230457,-0.12699 0.540868,-0.12699 0.310412,0 0.540869,0.12699 0.230457,0.12699 0.35274,0.3645 0.124635,0.23751 0.124635,0.55968 v 1.38744 q 0,0.32217 -0.124635,0.55968 -0.122283,0.23516 -0.35274,0.3645 -0.230457,0.12699 -0.540869,0.12699 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0706 0.124635,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41566 q 0,-0.17872 -0.0682,-0.31041 -0.06584,-0.13169 -0.19048,-0.20224 -0.124635,-0.0705 -0.291599,-0.0705 -0.166963,0 -0.291598,0.0705 -0.124635,0.0705 -0.192831,0.20224 -0.06584,0.13169 -0.06584,0.31041 v 1.41566 q 0,0.17872 0.06584,0.31041 0.0682,0.13169 0.192831,0.20224 0.124635,0.0706 0.291598,0.0706 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 95.279592,143.67956 h 0.463265 v 3.41923 h -0.463265 z m 0.232808,2.97948 h 1.58498 v 0.43975 H 95.5124 Z m 0,-1.47681 h 1.399203 v 0.4374 H 95.5124 Z m 0,-1.50267 h 1.58498 v 0.43975 H 95.5124 Z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 98.540361,143.67956 h 0.507946 l 0.736051,2.50916 -0.298654,0.38331 z m 1.434477,2.77253 q -0.0682,0.22811 -0.174019,0.37861 -0.10347,0.15051 -0.253973,0.22811 -0.150502,0.0753 -0.355092,0.0753 h -0.298653 v -0.45856 h 0.298653 q 0.101119,0 0.178722,-0.047 0.0776,-0.047 0.134041,-0.1364 0.05879,-0.0894 0.09642,-0.22575 l 0.705477,-2.58676 h 0.48443 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 102.45297,143.67956 h 0.46327 v 3.41923 h -0.46327 z m -0.56908,2.34925 q -0.26338,0 -0.45151,-0.11053 -0.18578,-0.11052 -0.28219,-0.32452 -0.0964,-0.214 -0.0964,-0.515 v -1.3992 h 0.46091 v 1.40861 q 0,0.23751 0.11758,0.36685 0.11994,0.12933 0.33393,0.12933 0.23281,0 0.3598,-0.14109 0.12698,-0.14345 0.12698,-0.40213 v -0.24221 h 0.15051 v 0.25397 q 0,0.30806 -0.0847,0.52911 -0.0847,0.2187 -0.24692,0.33393 -0.15991,0.11288 -0.38801,0.11288 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.8141,145.33273 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24691 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10818 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27278,0 0.47267,0.11052 0.20224,0.11053 0.30806,0.31747 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10817,0.20223 -0.30806,0.31276 -0.19989,0.10817 -0.47267,0.10817 h -0.84893 z m -0.24692,-1.65317 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.12528,143.67956 h 0.46326 v 3.41923 h -0.46326 z m 0.2328,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.39921 v 0.4374 h -1.39921 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.58817,145.23161 0.75016,-1.55205 h 0.52911 l -1.01119,1.95418 z m -0.0141,0.35274 0.40917,-0.23751 1.02765,1.75195 h -0.56908 z m -1.40626,-0.23751 0.40918,0.23751 -0.86774,1.51444 h -0.56909 z m -0.8842,-1.66728 h 0.52911 l 0.75016,1.55205 -0.26573,0.40213 z m 0.88185,1.50267 h 1.82014 v 0.4374 h -1.82014 z m 0.67961,-1.50267 h 0.46091 v 3.41923 h -0.46091 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.39374,143.67956 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.24287,143.67956 h 0.46326 v 3.41923 h -0.46326 z m -1.51914,0 h 0.46562 v 3.41923 h -0.46562 z m 0.29866,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.99379,147.09643 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41687 h 0.45385 v 2.61733 l -0.0564,-0.0611 1.31219,-2.55619 h 0.37626 v 3.41687 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.09859,143.67956 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 59.198444,149.21805 h 0.507946 l 0.736052,2.50916 -0.298654,0.38331 z m 1.434477,2.77254 q -0.0682,0.2281 -0.174018,0.3786 -0.103471,0.15051 -0.253973,0.22811 -0.150503,0.0753 -0.355092,0.0753 h -0.298653 v -0.45856 h 0.298653 q 0.101119,0 0.178722,-0.047 0.0776,-0.047 0.134041,-0.1364 0.05879,-0.0894 0.09642,-0.22575 l 0.70548,-2.58676 h 0.48443 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.310945,149.21805 h 0.463265 v 3.41923 h -0.463265 z m -1.519135,0 h 0.463266 v 3.41923 H 61.79181 Z m 0.298654,0 h 1.457993 v 0.43975 h -1.457993 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 64.674423,150.87122 h 0.863038 q 0.122283,0 0.211644,-0.0564 0.09171,-0.0564 0.141096,-0.16226 0.04938,-0.10583 0.04938,-0.24692 v -0.27279 q 0,-0.1458 -0.04938,-0.25162 -0.04938,-0.10817 -0.141096,-0.16461 -0.08936,-0.0588 -0.211644,-0.0588 h -0.863038 v -0.43975 h 0.848928 q 0.272786,0 0.472672,0.11052 0.202238,0.11053 0.30806,0.31747 0.108174,0.20459 0.108174,0.48208 v 0.28219 q 0,0.27749 -0.108174,0.47973 -0.108174,0.20224 -0.30806,0.31276 -0.199886,0.10817 -0.472672,0.10817 h -0.848928 z m -0.246918,-1.65317 h 0.463266 v 3.41923 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 67.54763,149.21805 h 0.409179 l 1.015891,3.41923 h -0.498539 l -0.721942,-2.73727 -0.724293,2.73727 h -0.496188 z m -0.475024,2.23402 h 1.389797 v 0.4374 h -1.389797 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 69.663621,152.20458 h 0.738403 q 0.251621,0 0.376256,-0.10582 0.124635,-0.10582 0.124635,-0.29865 v -0.23751 q 0,-0.15051 -0.05173,-0.25633 -0.05173,-0.10817 -0.152854,-0.16461 -0.101119,-0.0588 -0.251622,-0.0588 h -0.783083 v -0.42799 h 0.783083 q 0.199886,0 0.305708,-0.10818 0.105823,-0.11052 0.105823,-0.31981 v -0.18108 q 0,-0.19518 -0.112877,-0.29395 -0.112877,-0.10112 -0.329225,-0.10112 h -0.752512 v -0.43269 h 0.790138 q 0.282192,0 0.477375,0.0964 0.195183,0.0941 0.291599,0.27514 0.09877,0.17872 0.09877,0.42799 v 0.19048 q 0,0.16697 -0.05879,0.30571 -0.05879,0.13875 -0.178722,0.23281 -0.11758,0.0941 -0.286895,0.12699 0.17637,0.0259 0.305708,0.12463 0.129338,0.0988 0.195183,0.25162 0.0682,0.1505 0.0682,0.33863 v 0.23751 q 0,0.24927 -0.103471,0.4327 -0.101119,0.18342 -0.296302,0.28219 -0.195183,0.0964 -0.458562,0.0964 h -0.844225 z m -0.282192,-2.98653 h 0.463265 v 3.41923 h -0.463265 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.800776,152.19988 h 0.0024 q 0.141096,0 0.232809,-0.0659 0.09171,-0.0682 0.136392,-0.20458 0.04468,-0.13875 0.04468,-0.35039 v -2.36101 h 0.463265 v 2.36336 q 0,0.35744 -0.09171,0.5926 -0.09171,0.23281 -0.275137,0.34804 -0.183425,0.11523 -0.463266,0.11523 h -0.04938 z m 1.726076,-2.98183 h 0.463265 v 3.41923 h -0.463265 z m -1.011189,0 h 1.246349 v 0.43975 h -1.246349 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.641061,149.21805 h 0.463265 v 3.41923 h -0.463265 z m 0.232808,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.399203 v 0.4374 h -1.399203 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.490181,149.21805 h 0.463266 v 3.41923 h -0.463266 z m -1.519135,0 h 0.465618 v 3.41923 h -0.465618 z m 0.298654,1.51678 h 1.457993 v 0.4374 H 77.2697 Z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.241106,152.63493 v -2.58912 l 0.05644,0.0611 -1.30749,2.52798 h -0.383311 v -3.41688 h 0.453859 v 2.61733 l -0.05644,-0.0611 1.312193,-2.55619 h 0.376257 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.161913,151.26159 q -0.282192,0 -0.491485,-0.10817 -0.209292,-0.11053 -0.324521,-0.31512 -0.112877,-0.20694 -0.112877,-0.48443 v -0.24456 q 0,-0.27279 0.112877,-0.47503 0.112877,-0.20224 0.32217,-0.31041 0.209292,-0.10817 0.493836,-0.10817 h 0.834819 v 0.43975 h -0.86539 q -0.129338,0 -0.223402,0.0588 -0.09406,0.0564 -0.145799,0.16696 -0.05174,0.10817 -0.05174,0.25397 v 0.2187 q 0,0.14345 0.05174,0.24927 0.05173,0.10582 0.145799,0.16226 0.09642,0.0564 0.223402,0.0564 h 0.86539 v 0.43975 z m -0.216347,-0.214 0.437398,0.10818 -0.634933,1.48151 h -0.526759 z m 0.797193,-1.83189 h 0.463265 v 3.42158 h -0.463265 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 86.900058,152.67255 q -0.329225,0 -0.552627,-0.10347 -0.22105,-0.10347 -0.33863,-0.31747 -0.115229,-0.21399 -0.129338,-0.53851 v 0 h 0.467968 v 0 q 0.01646,0.26573 0.155206,0.39272 0.141096,0.12463 0.409179,0.12463 0.237511,0 0.369201,-0.12934 0.13169,-0.13169 0.13169,-0.3692 v -0.19283 q 0,-0.2187 -0.103471,-0.33863 -0.10347,-0.12228 -0.29395,-0.12228 h -0.498539 v -0.4374 h 0.498539 q 0.162261,0 0.251622,-0.10112 0.08936,-0.10112 0.08936,-0.2869 v -0.19988 q 0,-0.2093 -0.11758,-0.31747 -0.115228,-0.11052 -0.329224,-0.11052 -0.23516,0 -0.359795,0.12228 -0.124635,0.11993 -0.148151,0.37155 v 0 h -0.465617 v 0 q 0.02116,-0.31746 0.134041,-0.52441 0.112877,-0.20929 0.32217,-0.31041 0.209292,-0.10112 0.517352,-0.10112 0.291599,0 0.49854,0.0988 0.206941,0.0988 0.315114,0.2916 0.108174,0.19048 0.108174,0.46327 v 0.19753 q 0,0.19518 -0.09877,0.35744 -0.09642,0.15991 -0.277489,0.26103 0.206941,0.0659 0.319817,0.24927 0.112877,0.18107 0.112877,0.44916 v 0.19283 q 0,0.29395 -0.11758,0.50324 -0.115228,0.20694 -0.336279,0.31747 -0.22105,0.10817 -0.533813,0.10817 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 88.105979,152.19753 h 0.03998 q 0.223402,0 0.345686,-0.20224 0.122283,-0.20224 0.122283,-0.56909 v -2.20815 h 0.463265 v 2.25048 q 0,0.32452 -0.105822,0.55498 -0.10347,0.23046 -0.301005,0.35274 -0.197534,0.11993 -0.477375,0.11993 h -0.08701 z m -0.03527,0 h 0.463265 v 1.14758 h -0.463265 z m 0,0 h 2.443314 v 0.43975 h -2.443314 z m 2.23167,0 h 0.463265 v 1.14758 h -0.463265 z m -0.397421,-2.97948 h 0.463266 v 3.41923 h -0.463266 z m -0.992376,0 h 1.206372 v 0.43975 h -1.206372 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 91.465968,150.87122 h 0.863037 q 0.122284,0 0.211645,-0.0564 0.09171,-0.0564 0.141096,-0.16226 0.04938,-0.10583 0.04938,-0.24692 v -0.27279 q 0,-0.1458 -0.04938,-0.25162 -0.04938,-0.10817 -0.141096,-0.16461 -0.08936,-0.0588 -0.211645,-0.0588 h -0.863037 v -0.43975 h 0.848928 q 0.272786,0 0.472672,0.11052 0.202237,0.11053 0.30806,0.31747 0.108173,0.20459 0.108173,0.48208 v 0.28219 q 0,0.27749 -0.108173,0.47973 -0.108174,0.20224 -0.30806,0.31276 -0.199886,0.10817 -0.472672,0.10817 h -0.848928 z m -0.246919,-1.65317 h 0.463266 v 3.41923 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13607"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.339175,149.21805 h 0.409179 l 1.015892,3.41923 h -0.49854 l -0.721941,-2.73727 -0.724294,2.73727 h -0.496188 z m -0.475023,2.23402 h 1.389796 v 0.4374 h -1.389796 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96.455166,152.20458 h 0.738403 q 0.251621,0 0.376256,-0.10582 0.124635,-0.10582 0.124635,-0.29865 v -0.23751 q 0,-0.15051 -0.05174,-0.25633 -0.05174,-0.10817 -0.152854,-0.16461 -0.101119,-0.0588 -0.251622,-0.0588 h -0.783083 v -0.42799 h 0.783083 q 0.199886,0 0.305708,-0.10818 0.105822,-0.11052 0.105822,-0.31981 v -0.18108 q 0,-0.19518 -0.112876,-0.29395 -0.112877,-0.10112 -0.329225,-0.10112 h -0.752512 v -0.43269 h 0.790138 q 0.282192,0 0.477375,0.0964 0.195183,0.0941 0.291599,0.27514 0.09877,0.17872 0.09877,0.42799 v 0.19048 q 0,0.16697 -0.05879,0.30571 -0.05879,0.13875 -0.178722,0.23281 -0.11758,0.0941 -0.286895,0.12699 0.17637,0.0259 0.305708,0.12463 0.129338,0.0988 0.195183,0.25162 0.0682,0.1505 0.0682,0.33863 v 0.23751 q 0,0.24927 -0.10347,0.4327 -0.101119,0.18342 -0.296302,0.28219 -0.195183,0.0964 -0.458562,0.0964 h -0.844225 z m -0.282192,-2.98653 h 0.463265 v 3.41923 h -0.463265 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.631729,152.67255 q -0.310411,0 -0.540868,-0.12699 -0.230457,-0.12933 -0.355092,-0.36449 -0.122283,-0.23752 -0.122283,-0.55968 v -1.38745 q 0,-0.32217 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.3645 0.230457,-0.12699 0.540868,-0.12699 0.310412,0 0.540871,0.12699 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32216 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.36449 -0.230459,0.12699 -0.540871,0.12699 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0705 0.124632,-0.0705 0.190482,-0.20223 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.190482,-0.20224 -0.124635,-0.0705 -0.291599,-0.0705 -0.166964,0 -0.291598,0.0705 -0.124635,0.0705 -0.192832,0.20224 -0.06585,0.13169 -0.06585,0.31041 v 1.41567 q 0,0.17872 0.06585,0.31041 0.0682,0.13169 0.192832,0.20223 0.124634,0.0705 0.291598,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 102.15925,152.67255 q -0.31041,0 -0.54087,-0.12699 -0.23046,-0.12933 -0.35509,-0.36449 -0.12229,-0.23752 -0.12229,-0.55968 v -1.38745 q 0,-0.32217 0.12229,-0.55968 0.12463,-0.23751 0.35509,-0.3645 0.23046,-0.12699 0.54087,-0.12699 0.31041,0 0.54087,0.12699 0.23045,0.12699 0.35274,0.3645 0.12463,0.23751 0.12463,0.55968 v 1.38745 q 0,0.32216 -0.12463,0.55968 -0.12229,0.23516 -0.35274,0.36449 -0.23046,0.12699 -0.54087,0.12699 z m 0,-0.45386 q 0.16696,0 0.2916,-0.0705 0.12463,-0.0705 0.19048,-0.20223 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12464,-0.0705 -0.2916,-0.0705 -0.16697,0 -0.2916,0.0705 -0.12464,0.0705 -0.19283,0.20224 -0.0658,0.13169 -0.0658,0.31041 v 1.41567 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19283,0.20223 0.12463,0.0705 0.2916,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 104.44691,151.13931 -0.0752,-0.12229 -0.91948,-1.79897 h 0.50795 l 0.65139,1.38744 0.08,0.13404 0.97826,1.89775 h -0.50794 z m -0.0235,-0.45621 0.68667,-1.46505 h 0.50795 l -0.94299,1.85306 -0.74311,1.56617 h -0.50795 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.31363,150.87122 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10583 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27278,0 0.47267,0.11052 0.20224,0.11053 0.30806,0.31747 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19989,0.10817 -0.47267,0.10817 h -0.84893 z m -0.24692,-1.65317 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.18684,149.21805 h 0.40917 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73727 -0.72429,2.73727 h -0.49619 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13621"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.53977,149.21805 h 0.46326 v 3.41923 h -0.46326 z m -1.51914,0 h 0.46562 v 3.41923 h -0.46562 z m 0.29866,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.65633,149.21805 h 0.46327 v 3.41923 h -0.46327 z m 0.23281,2.97948 h 1.58498 v 0.43975 h -1.58498 z m 0,-1.47681 h 1.3992 v 0.4374 h -1.3992 z m 0,-1.50267 h 1.58498 v 0.43975 h -1.58498 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.50545,149.21805 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.25637,152.63493 v -2.58912 l 0.0564,0.0611 -1.30749,2.52798 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.31219,-2.55619 h 0.37626 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.17718,151.26159 q -0.28219,0 -0.49148,-0.10817 -0.2093,-0.11053 -0.32452,-0.31512 -0.11288,-0.20694 -0.11288,-0.48443 v -0.24456 q 0,-0.27279 0.11288,-0.47503 0.11287,-0.20224 0.32216,-0.31041 0.2093,-0.10817 0.49384,-0.10817 h 0.83482 v 0.43975 h -0.86539 q -0.12934,0 -0.2234,0.0588 -0.0941,0.0564 -0.1458,0.16696 -0.0517,0.10817 -0.0517,0.25397 v 0.2187 q 0,0.14345 0.0517,0.24927 0.0517,0.10582 0.1458,0.16226 0.0964,0.0564 0.2234,0.0564 h 0.86539 v 0.43975 z m -0.21635,-0.214 0.4374,0.10818 -0.63493,1.48151 h -0.52676 z m 0.7972,-1.83189 h 0.46326 v 3.42158 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.462682,156.40972 h 0.863038 q 0.122284,0 0.211644,-0.0564 0.09171,-0.0564 0.141097,-0.16226 0.04938,-0.10582 0.04938,-0.24692 v -0.27279 q 0,-0.1458 -0.04938,-0.25162 -0.04938,-0.10817 -0.141097,-0.16461 -0.08936,-0.0588 -0.211644,-0.0588 h -0.863038 v -0.43975 h 0.848929 q 0.272785,0 0.472672,0.11053 0.202237,0.11052 0.308059,0.31746 0.108174,0.20459 0.108174,0.48208 v 0.28219 q 0,0.27749 -0.108174,0.47973 -0.108173,0.20224 -0.308059,0.31276 -0.199887,0.10818 -0.472672,0.10818 h -0.848929 z m -0.246918,-1.65318 h 0.463266 v 3.41923 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.688629,158.21104 q -0.310411,0 -0.540868,-0.12698 -0.230457,-0.12934 -0.355092,-0.3645 -0.122283,-0.23751 -0.122283,-0.55968 v -1.38745 q 0,-0.32217 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.3645 0.230457,-0.12698 0.540868,-0.12698 0.310412,0 0.540869,0.12698 0.230457,0.12699 0.35274,0.3645 0.124635,0.23751 0.124635,0.55968 v 1.38745 q 0,0.32217 -0.124635,0.55968 -0.122283,0.23516 -0.35274,0.3645 -0.230457,0.12698 -0.540869,0.12698 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0705 0.124635,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.06584,-0.13169 -0.19048,-0.20224 -0.124635,-0.0705 -0.291599,-0.0705 -0.166963,0 -0.291598,0.0705 -0.124635,0.0705 -0.192831,0.20224 -0.06585,0.13169 -0.06585,0.31041 v 1.41567 q 0,0.17872 0.06585,0.31041 0.0682,0.13169 0.192831,0.20224 0.124635,0.0705 0.291598,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 58.183228,158.21104 q -0.301005,0 -0.524407,-0.12933 -0.221051,-0.12934 -0.340982,-0.36921 -0.119932,-0.24221 -0.119932,-0.56908 v -1.35217 q 0,-0.32923 0.119932,-0.56909 0.119931,-0.24222 0.340982,-0.37156 0.223402,-0.12933 0.524407,-0.12933 0.291599,0 0.503243,0.11758 0.211644,0.11758 0.331576,0.34568 0.122283,0.22811 0.143447,0.55498 v 0 h -0.47032 v 0 q -0.01646,-0.18107 -0.08231,-0.30806 -0.06585,-0.12699 -0.17637,-0.19283 -0.108174,-0.0658 -0.24927,-0.0658 -0.157557,0 -0.272786,0.0753 -0.115228,0.0753 -0.178721,0.21399 -0.06349,0.13875 -0.06349,0.32923 v 1.35217 q 0,0.18812 0.06349,0.32922 0.06349,0.13874 0.178721,0.214 0.115229,0.0729 0.272786,0.0729 0.141096,0 0.24927,-0.0635 0.110525,-0.0635 0.17637,-0.19048 0.06584,-0.12698 0.08231,-0.31276 v 0 h 0.47032 v 0 q -0.02116,0.32687 -0.143447,0.55498 -0.119932,0.2281 -0.331576,0.34568 -0.211644,0.11758 -0.503243,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13637"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 60.567302,158.21104 q -0.301005,0 -0.524407,-0.12933 -0.221051,-0.12934 -0.340983,-0.36921 -0.119931,-0.24221 -0.119931,-0.56908 v -1.35217 q 0,-0.32923 0.119931,-0.56909 0.119932,-0.24222 0.340983,-0.37156 0.223402,-0.12933 0.524407,-0.12933 0.291598,0 0.503243,0.11758 0.211644,0.11758 0.331575,0.34568 0.122284,0.22811 0.143448,0.55498 v 0 h -0.47032 v 0 q -0.01646,-0.18107 -0.08231,-0.30806 -0.06584,-0.12699 -0.17637,-0.19283 -0.108174,-0.0658 -0.24927,-0.0658 -0.157557,0 -0.272786,0.0753 -0.115228,0.0753 -0.178722,0.21399 -0.06349,0.13875 -0.06349,0.32923 v 1.35217 q 0,0.18812 0.06349,0.32922 0.06349,0.13874 0.178722,0.214 0.115229,0.0729 0.272786,0.0729 0.141096,0 0.24927,-0.0635 0.110525,-0.0635 0.17637,-0.19048 0.06585,-0.12698 0.08231,-0.31276 v 0 h 0.47032 v 0 q -0.02116,0.32687 -0.143448,0.55498 -0.119931,0.2281 -0.331575,0.34568 -0.211645,0.11758 -0.503243,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.680371,158.17342 v -2.58912 l 0.05644,0.0611 -1.307491,2.52797 h -0.383311 v -3.41688 h 0.453859 v 2.61733 l -0.05644,-0.0611 1.312194,-2.55619 h 0.376256 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.419537,158.17342 v -2.58912 l 0.05644,0.0611 -1.30749,2.52797 h -0.383311 v -3.41688 h 0.453859 v 2.61733 l -0.05644,-0.0611 1.312194,-2.55619 h 0.376256 v 3.41688 z m 0.110525,-4.37868 q 0,0.34098 -0.183425,0.52911 -0.181073,0.18812 -0.515001,0.18812 h -0.01881 q -0.331576,0 -0.515001,-0.18812 -0.181073,-0.18813 -0.181073,-0.52911 l 0.388014,0.005 q 0,0.17402 0.07995,0.27043 0.07995,0.0964 0.228106,0.0964 h 0.01881 q 0.148151,0 0.228106,-0.0964 0.08231,-0.0964 0.08231,-0.27043 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.476738,158.21104 q -0.301005,0 -0.524408,-0.12933 -0.22105,-0.12934 -0.340982,-0.36921 -0.119931,-0.24221 -0.119931,-0.56908 v -1.35217 q 0,-0.32923 0.119931,-0.56909 0.119932,-0.24222 0.340982,-0.37156 0.223403,-0.12933 0.524408,-0.12933 0.291598,0 0.503242,0.11758 0.211645,0.11758 0.331576,0.34568 0.122283,0.22811 0.143448,0.55498 v 0 h -0.47032 v 0 q -0.01646,-0.18107 -0.08231,-0.30806 -0.06584,-0.12699 -0.176371,-0.19283 -0.108173,-0.0658 -0.249269,-0.0658 -0.157558,0 -0.272786,0.0753 -0.115229,0.0753 -0.178722,0.21399 -0.06349,0.13875 -0.06349,0.32923 v 1.35217 q 0,0.18812 0.06349,0.32922 0.06349,0.13874 0.178722,0.214 0.115228,0.0729 0.272786,0.0729 0.141096,0 0.249269,-0.0635 0.110526,-0.0635 0.176371,-0.19048 0.06584,-0.12698 0.08231,-0.31276 v 0 h 0.47032 v 0 q -0.02116,0.32687 -0.143448,0.55498 -0.119931,0.2281 -0.331576,0.34568 -0.211644,0.11758 -0.503242,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.783207,156.3086 0.736052,-1.55206 h 0.52911 l -0.999431,1.95418 z m -0.01411,0.35274 0.409178,-0.23751 1.013541,1.75194 h -0.569088 z m -0.813654,-1.9048 h 0.463265 v 3.41923 h -0.463265 z m 0.232808,1.50267 h 0.992376 v 0.4374 h -0.992376 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.371871,158.21104 q -0.310411,0 -0.540868,-0.12698 -0.230457,-0.12934 -0.355092,-0.3645 -0.122283,-0.23751 -0.122283,-0.55968 v -1.38745 q 0,-0.32217 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.3645 0.230457,-0.12698 0.540868,-0.12698 0.310412,0 0.540869,0.12698 0.230457,0.12699 0.35274,0.3645 0.124635,0.23751 0.124635,0.55968 v 1.38745 q 0,0.32217 -0.124635,0.55968 -0.122283,0.23516 -0.35274,0.3645 -0.230457,0.12698 -0.540869,0.12698 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0705 0.124635,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.06584,-0.13169 -0.19048,-0.20224 -0.124635,-0.0705 -0.291599,-0.0705 -0.166963,0 -0.291598,0.0705 -0.124635,0.0705 -0.192832,0.20224 -0.06584,0.13169 -0.06584,0.31041 v 1.41567 q 0,0.17872 0.06584,0.31041 0.0682,0.13169 0.192832,0.20224 0.124635,0.0705 0.291598,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.595466,158.17342 v -2.58912 l 0.05644,0.0611 -1.30749,2.52797 h -0.383311 v -3.41688 h 0.453859 v 2.61733 l -0.05644,-0.0611 1.312194,-2.55619 h 0.376256 v 3.41688 z m 0.110525,-4.37868 q 0,0.34098 -0.183425,0.52911 -0.181073,0.18812 -0.515001,0.18812 h -0.01881 q -0.331576,0 -0.515001,-0.18812 -0.181073,-0.18813 -0.181073,-0.52911 l 0.388014,0.005 q 0,0.17402 0.07995,0.27043 0.07995,0.0964 0.228106,0.0964 h 0.01881 q 0.148151,0 0.228106,-0.0964 0.08231,-0.0964 0.08231,-0.27043 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.126672,157.81127 q -0.458563,0 -0.785435,-0.14345 -0.324521,-0.14344 -0.496188,-0.42093 -0.169315,-0.27749 -0.169315,-0.67021 v -0.33863 q 0,-0.39272 0.169315,-0.67021 0.171667,-0.27749 0.496188,-0.42093 0.326872,-0.14345 0.785435,-0.14345 0.460914,0 0.785435,0.14345 0.326872,0.14344 0.496188,0.42093 0.169315,0.27749 0.169315,0.67021 v 0.33863 q 0,0.39272 -0.169315,0.67021 -0.169316,0.27749 -0.496188,0.42093 -0.324521,0.14345 -0.785435,0.14345 z m -0.230457,-3.17231 h 0.463265 v 3.53681 h -0.463265 z m 0.230457,2.73491 q 0.477375,0 0.738403,-0.20459 0.261027,-0.20694 0.261027,-0.5926 v -0.33863 q 0,-0.38566 -0.261027,-0.59025 -0.261028,-0.20694 -0.738403,-0.20694 -0.475024,0 -0.738403,0.20694 -0.261028,0.20459 -0.261028,0.59025 v 0.33863 q 0,0.38566 0.261028,0.5926 0.263379,0.20459 0.738403,0.20459 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.033368,154.75654 h 0.463266 v 3.41923 h -0.463266 z m 0.232809,2.97948 h 1.584979 v 0.43975 h -1.584979 z m 0,-1.47681 h 1.399203 v 0.4374 h -1.399203 z m 0,-1.50267 h 1.584979 v 0.43975 h -1.584979 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 84.154062,157.73602 h 0.03998 q 0.223402,0 0.345685,-0.20224 0.122283,-0.20224 0.122283,-0.56909 v -2.20815 h 0.463266 v 2.25048 q 0,0.32452 -0.105822,0.55498 -0.103471,0.23046 -0.301005,0.35274 -0.197535,0.11993 -0.477375,0.11993 h -0.08701 z m -0.03527,0 h 0.463266 v 1.14758 h -0.463266 z m 0,0 h 2.443314 v 0.43975 h -2.443314 z m 2.23167,0 h 0.463266 v 1.14758 h -0.463266 z m -0.39742,-2.97948 h 0.463265 v 3.41923 h -0.463265 z m -0.992376,0 h 1.206371 v 0.43975 h -1.206371 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 87.267133,154.75654 h 0.463266 v 3.41923 h -0.463266 z m 0.232809,2.97948 h 1.584979 v 0.43975 h -1.584979 z m 0,-1.47681 h 1.399203 v 0.4374 h -1.399203 z m 0,-1.50267 h 1.584979 v 0.43975 h -1.584979 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 89.844038,156.40972 h 0.863038 q 0.122283,0 0.211644,-0.0564 0.09171,-0.0564 0.141096,-0.16226 0.04938,-0.10582 0.04938,-0.24692 v -0.27279 q 0,-0.1458 -0.04938,-0.25162 -0.04938,-0.10817 -0.141096,-0.16461 -0.08936,-0.0588 -0.211644,-0.0588 h -0.863038 v -0.43975 h 0.848928 q 0.272786,0 0.472672,0.11053 0.202238,0.11052 0.30806,0.31746 0.108173,0.20459 0.108173,0.48208 v 0.28219 q 0,0.27749 -0.108173,0.47973 -0.108174,0.20224 -0.30806,0.31276 -0.199886,0.10818 -0.472672,0.10818 h -0.848928 z m -0.246918,-1.65318 h 0.463265 v 3.41923 H 89.59712 Z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.717244,154.75654 h 0.409178 l 1.015892,3.41923 h -0.498539 l -0.721942,-2.73726 -0.724293,2.73726 h -0.496188 z m -0.475024,2.23402 h 1.389797 v 0.4374 H 92.24222 Z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96.072532,154.75654 h 0.463265 v 3.41923 h -0.463265 z m -1.220481,2.97948 h 1.639066 v 0.43975 h -1.639066 z m 1.617902,0 h 0.463265 v 1.14758 h -0.463265 z m -1.918907,-2.97948 h 0.463265 v 3.41923 h -0.463265 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13665"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.020988,158.17342 v -2.58912 l 0.05644,0.0611 -1.30749,2.52797 h -0.383311 v -3.41688 h 0.453859 v 2.61733 l -0.05644,-0.0611 1.312194,-2.55619 h 0.376256 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 101.76015,158.17342 v -2.58912 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61733 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.99092,154.75654 h 0.46327 v 3.41923 h -0.46327 z m 0.26808,0 h 1.29339 v 0.43975 H 104.259 Z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.62013,157.68899 h 0.48678 v 0.48678 h -0.48678 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.61752,156.3086 0.73605,-1.55206 h 0.52911 l -0.99943,1.95418 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 h -0.56909 z m -0.81365,-1.9048 h 0.46326 v 3.41923 h -0.46326 z m 0.23281,1.50267 h 0.99237 v 0.4374 h -0.99237 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.65591,156.40972 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10818,0.20459 0.10818,0.48208 v 0.28219 q 0,0.27749 -0.10818,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19988,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13677"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 113.52912,154.75654 h 0.40918 l 1.01589,3.41923 h -0.49854 l -0.72194,-2.73726 -0.7243,2.73726 h -0.49618 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.22125,158.21104 q -0.301,0 -0.52441,-0.12933 -0.22105,-0.12934 -0.34098,-0.36921 -0.11993,-0.24221 -0.11993,-0.56908 v -1.35217 q 0,-0.32923 0.11993,-0.56909 0.11993,-0.24222 0.34098,-0.37156 0.22341,-0.12933 0.52441,-0.12933 0.2916,0 0.50324,0.11758 0.21165,0.11758 0.33158,0.34568 0.12228,0.22811 0.14345,0.55498 v 0 h -0.47032 v 0 q -0.0165,-0.18107 -0.0823,-0.30806 -0.0658,-0.12699 -0.17637,-0.19283 -0.10817,-0.0658 -0.24927,-0.0658 -0.15756,0 -0.27278,0.0753 -0.11523,0.0753 -0.17873,0.21399 -0.0635,0.13875 -0.0635,0.32923 v 1.35217 q 0,0.18812 0.0635,0.32922 0.0635,0.13874 0.17873,0.214 0.11522,0.0729 0.27278,0.0729 0.1411,0 0.24927,-0.0635 0.11053,-0.0635 0.17637,-0.19048 0.0658,-0.12698 0.0823,-0.31276 v 0 h 0.47032 v 0 q -0.0212,0.32687 -0.14345,0.55498 -0.11993,0.2281 -0.33158,0.34568 -0.21164,0.11758 -0.50324,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.21909,154.75654 h 0.46327 v 3.41923 h -0.46327 z m -1.51913,0 h 0.46561 v 3.41923 h -0.46561 z m 0.29865,1.51678 h 1.45799 v 0.4374 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.32097,158.21104 q -0.31041,0 -0.54086,-0.12698 -0.23046,-0.12934 -0.3551,-0.3645 -0.12228,-0.23751 -0.12228,-0.55968 v -1.38745 q 0,-0.32217 0.12228,-0.55968 0.12464,-0.23751 0.3551,-0.3645 0.23045,-0.12698 0.54086,-0.12698 0.31042,0 0.54087,0.12698 0.23046,0.12699 0.35274,0.3645 0.12464,0.23751 0.12464,0.55968 v 1.38745 q 0,0.32217 -0.12464,0.55968 -0.12228,0.23516 -0.35274,0.3645 -0.23045,0.12698 -0.54087,0.12698 z m 0,-0.45386 q 0.16697,0 0.2916,-0.0705 0.12464,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.0658,-0.13169 -0.19048,-0.20224 -0.12463,-0.0705 -0.2916,-0.0705 -0.16696,0 -0.29159,0.0705 -0.12464,0.0705 -0.19284,0.20224 -0.0658,0.13169 -0.0658,0.31041 v 1.41567 q 0,0.17872 0.0658,0.31041 0.0682,0.13169 0.19284,0.20224 0.12463,0.0705 0.29159,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.65388,157.73602 h 0.04 q 0.2234,0 0.34568,-0.20224 0.12229,-0.20224 0.12229,-0.56909 v -2.20815 h 0.46326 v 2.25048 q 0,0.32452 -0.10582,0.55498 -0.10347,0.23046 -0.30101,0.35274 -0.19753,0.11993 -0.47737,0.11993 h -0.087 z m -0.0353,0 h 0.46326 v 1.14758 h -0.46326 z m 0,0 h 2.44331 v 0.43975 h -2.44331 z m 2.23167,0 h 0.46326 v 1.14758 h -0.46326 z m -0.39743,-2.97948 h 0.46327 v 3.41923 h -0.46327 z m -0.99237,0 h 1.20637 v 0.43975 h -1.20637 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.68172,154.75654 h 0.40918 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73726 -0.72429,2.73726 h -0.49619 z m -0.47502,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.76244,156.40972 h 0.86304 q 0.12228,0 0.21164,-0.0564 0.0917,-0.0564 0.1411,-0.16226 0.0494,-0.10582 0.0494,-0.24692 v -0.27279 q 0,-0.1458 -0.0494,-0.25162 -0.0494,-0.10817 -0.1411,-0.16461 -0.0894,-0.0588 -0.21164,-0.0588 h -0.86304 v -0.43975 h 0.84893 q 0.27279,0 0.47267,0.11053 0.20224,0.11052 0.30806,0.31746 0.10817,0.20459 0.10817,0.48208 v 0.28219 q 0,0.27749 -0.10817,0.47973 -0.10817,0.20224 -0.30806,0.31276 -0.19988,0.10818 -0.47267,0.10818 h -0.84893 z m -0.24692,-1.65318 h 0.46327 v 3.41923 h -0.46327 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 58.588429,160.29503 h 0.463265 v 1.19932 h -0.463265 z m 0.693722,0 h 0.463266 v 1.19932 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 60.27878,160.29503 h 0.463265 v 3.41923 H 60.27878 Z m 0.268082,0 h 1.293381 v 0.43975 h -1.293381 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.175502,163.74954 q -0.310411,0 -0.540868,-0.12699 -0.230457,-0.12934 -0.355092,-0.3645 -0.122283,-0.23751 -0.122283,-0.55968 v -1.38745 q 0,-0.32216 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.36449 0.230457,-0.12699 0.540868,-0.12699 0.310412,0 0.540869,0.12699 0.230457,0.12698 0.35274,0.36449 0.124635,0.23752 0.124635,0.55968 v 1.38745 q 0,0.32217 -0.124635,0.55968 -0.122283,0.23516 -0.35274,0.3645 -0.230457,0.12699 -0.540869,0.12699 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0705 0.124635,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.06585,-0.13169 -0.19048,-0.20223 -0.124635,-0.0705 -0.291599,-0.0705 -0.166963,0 -0.291598,0.0705 -0.124635,0.0705 -0.192831,0.20223 -0.06585,0.13169 -0.06585,0.31041 v 1.41567 q 0,0.17872 0.06585,0.31041 0.0682,0.13169 0.192831,0.20224 0.124635,0.0705 0.291598,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 65.011653,161.94821 h 0.863038 q 0.122283,0 0.211644,-0.0564 0.09171,-0.0564 0.141096,-0.16226 0.04938,-0.10582 0.04938,-0.24692 v -0.27278 q 0,-0.1458 -0.04938,-0.25163 -0.04938,-0.10817 -0.141096,-0.16461 -0.08936,-0.0588 -0.211644,-0.0588 h -0.863038 v -0.43975 h 0.848928 q 0.272786,0 0.472672,0.11053 0.202238,0.11052 0.30806,0.31746 0.108173,0.20459 0.108173,0.48208 v 0.28219 q 0,0.27749 -0.108173,0.47973 -0.108174,0.20224 -0.30806,0.31276 -0.199886,0.10818 -0.472672,0.10818 h -0.848928 z m -0.246918,-1.65318 H 65.228 v 3.41923 h -0.463265 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.237599,163.74954 q -0.310411,0 -0.540868,-0.12699 -0.230457,-0.12934 -0.355092,-0.3645 -0.122283,-0.23751 -0.122283,-0.55968 v -1.38745 q 0,-0.32216 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.36449 0.230457,-0.12699 0.540868,-0.12699 0.310412,0 0.540869,0.12699 0.230457,0.12698 0.35274,0.36449 0.124635,0.23752 0.124635,0.55968 v 1.38745 q 0,0.32217 -0.124635,0.55968 -0.122283,0.23516 -0.35274,0.3645 -0.230457,0.12699 -0.540869,0.12699 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0705 0.124635,-0.0705 0.19048,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.06584,-0.13169 -0.19048,-0.20223 -0.124635,-0.0705 -0.291599,-0.0705 -0.166963,0 -0.291598,0.0705 -0.124635,0.0705 -0.192832,0.20223 -0.06584,0.13169 -0.06584,0.31041 v 1.41567 q 0,0.17872 0.06584,0.31041 0.0682,0.13169 0.192832,0.20224 0.124635,0.0705 0.291598,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 69.570508,163.27451 h 0.03998 q 0.223402,0 0.345685,-0.20224 0.122284,-0.20223 0.122284,-0.56908 v -2.20816 h 0.463265 v 2.25049 q 0,0.32452 -0.105822,0.55497 -0.10347,0.23046 -0.301005,0.35274 -0.197534,0.11994 -0.477375,0.11994 h -0.08701 z m -0.03527,0 h 0.463265 v 1.14758 h -0.463265 z m 0,0 h 2.443314 v 0.43975 h -2.443314 z m 2.23167,0 h 0.463265 v 1.14758 h -0.463265 z m -0.397421,-2.97948 h 0.463266 v 3.41923 h -0.463266 z m -0.992376,0 h 1.206372 v 0.43975 h -1.206372 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.659492,163.74954 q -0.301005,0 -0.524407,-0.12934 -0.221051,-0.12934 -0.340983,-0.3692 -0.119931,-0.24222 -0.119931,-0.56909 v -1.35217 q 0,-0.32923 0.119931,-0.56909 0.119932,-0.24222 0.340983,-0.37155 0.223402,-0.12934 0.524407,-0.12934 0.291598,0 0.503243,0.11758 0.211644,0.11758 0.331575,0.34568 0.122284,0.22811 0.143448,0.55498 v 0 h -0.47032 v 0 q -0.01646,-0.18107 -0.08231,-0.30806 -0.06584,-0.12698 -0.17637,-0.19283 -0.108174,-0.0658 -0.24927,-0.0658 -0.157558,0 -0.272786,0.0752 -0.115228,0.0753 -0.178722,0.21399 -0.06349,0.13875 -0.06349,0.32923 v 1.35217 q 0,0.18813 0.06349,0.32922 0.06349,0.13875 0.178722,0.214 0.115228,0.0729 0.272786,0.0729 0.141096,0 0.24927,-0.0635 0.110525,-0.0635 0.17637,-0.19048 0.06584,-0.12698 0.08231,-0.31276 v 0 h 0.47032 v 0 q -0.02116,0.32687 -0.143448,0.55498 -0.119931,0.22811 -0.331575,0.34569 -0.211645,0.11758 -0.503243,0.11758 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.965963,161.84709 0.736051,-1.55206 h 0.52911 l -0.99943,1.95418 z m -0.01411,0.35274 0.409179,-0.23751 1.01354,1.75194 h -0.569088 z m -0.813654,-1.9048 h 0.463265 v 3.41923 h -0.463265 z m 0.232808,1.50268 h 0.992376 v 0.43739 h -0.992376 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.484078,160.29503 h 0.409179 l 1.015892,3.41923 h -0.49854 l -0.721941,-2.73726 -0.724294,2.73726 h -0.496188 z m -0.475023,2.23402 h 1.389796 v 0.4374 h -1.389796 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13709"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.133882,162.33857 q -0.282192,0 -0.491484,-0.10817 -0.209293,-0.11052 -0.324521,-0.31511 Q 80.205,161.70835 80.205,161.43086 v -0.24457 q 0,-0.27279 0.112877,-0.47502 0.112877,-0.20224 0.322169,-0.31042 0.209293,-0.10817 0.493836,-0.10817 h 0.834819 v 0.43975 h -0.865389 q -0.129338,0 -0.223402,0.0588 -0.09407,0.0564 -0.1458,0.16696 -0.05174,0.10818 -0.05174,0.25398 v 0.2187 q 0,0.14344 0.05174,0.24927 0.05173,0.10582 0.1458,0.16226 0.09642,0.0564 0.223402,0.0564 h 0.865389 v 0.43975 z m -0.216347,-0.21399 0.437398,0.10817 -0.634932,1.48151 h -0.526759 z m 0.797193,-1.8319 h 0.463266 v 3.42158 h -0.463266 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 85.474037,160.29503 h 0.463266 v 3.41923 h -0.463266 z m -1.519134,0 h 0.463265 v 3.41923 h -0.463265 z m 0.298653,0 h 1.457993 v 0.43975 h -1.457993 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 87.575918,163.74954 q -0.310411,0 -0.540868,-0.12699 -0.230457,-0.12934 -0.355092,-0.3645 -0.122283,-0.23751 -0.122283,-0.55968 v -1.38745 q 0,-0.32216 0.122283,-0.55968 0.124635,-0.23751 0.355092,-0.36449 0.230457,-0.12699 0.540868,-0.12699 0.310412,0 0.540869,0.12699 0.230456,0.12698 0.35274,0.36449 0.124635,0.23752 0.124635,0.55968 v 1.38745 q 0,0.32217 -0.124635,0.55968 -0.122284,0.23516 -0.35274,0.3645 -0.230457,0.12699 -0.540869,0.12699 z m 0,-0.45386 q 0.166964,0 0.291599,-0.0705 0.124635,-0.0705 0.190479,-0.20224 0.0682,-0.13169 0.0682,-0.31041 v -1.41567 q 0,-0.17872 -0.0682,-0.31041 -0.06584,-0.13169 -0.190479,-0.20223 -0.124635,-0.0705 -0.291599,-0.0705 -0.166964,0 -0.291598,0.0705 -0.124635,0.0705 -0.192832,0.20223 -0.06584,0.13169 -0.06584,0.31041 v 1.41567 q 0,0.17872 0.06584,0.31041 0.0682,0.13169 0.192832,0.20224 0.124634,0.0705 0.291598,0.0705 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 89.064031,163.27686 h 0.0024 q 0.141096,0 0.232809,-0.0658 0.09171,-0.0682 0.136392,-0.20459 0.04468,-0.13875 0.04468,-0.35039 v -2.36101 h 0.463265 v 2.36336 q 0,0.35745 -0.09171,0.59261 -0.09171,0.2328 -0.275137,0.34803 -0.183425,0.11523 -0.463266,0.11523 h -0.04938 z m 1.726076,-2.98183 h 0.463265 v 3.41923 h -0.463265 z m -1.011189,0 h 1.246349 v 0.43975 h -1.246349 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 93.538681,163.71191 v -2.58911 l 0.05644,0.0611 -1.30749,2.52797 h -0.383311 v -3.41688 h 0.453859 v 2.61734 l -0.05644,-0.0611 1.312194,-2.55619 h 0.376256 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 95.471244,161.84709 0.736051,-1.55206 h 0.529111 l -0.999431,1.95418 z m -0.01411,0.35274 0.409179,-0.23751 1.01354,1.75194 h -0.569087 z m -0.813654,-1.9048 h 0.463266 v 3.41923 H 94.64348 Z m 0.232809,1.50268 h 0.992376 v 0.43739 h -0.992376 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 97.161598,163.27686 h 0.0024 q 0.141096,0 0.232808,-0.0658 0.09171,-0.0682 0.136393,-0.20459 0.04468,-0.13875 0.04468,-0.35039 v -2.36101 h 0.463266 v 2.36336 q 0,0.35745 -0.09171,0.59261 -0.09171,0.2328 -0.275138,0.34803 -0.183425,0.11523 -0.463265,0.11523 h -0.04938 z m 1.726076,-2.98183 h 0.463265 v 3.41923 h -0.463265 z m -1.011189,0 h 1.246349 v 0.43975 h -1.246349 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 101.63625,163.71191 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61734 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 104.26018,160.29503 h 0.46327 v 3.41923 h -0.46327 z m -1.51914,0 h 0.46562 v 3.41923 h -0.46562 z m 0.29866,1.51679 h 1.45799 v 0.43739 h -1.45799 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 107.0111,163.71191 v -2.58911 l 0.0564,0.0611 -1.30749,2.52797 h -0.38331 v -3.41688 h 0.45386 v 2.61734 l -0.0564,-0.0611 1.3122,-2.55619 h 0.37625 v 3.41688 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.94367,161.84709 0.73605,-1.55206 h 0.52911 l -0.99943,1.95418 z m -0.0141,0.35274 0.40918,-0.23751 1.01354,1.75194 h -0.56909 z m -0.81365,-1.9048 h 0.46326 v 3.41923 h -0.46326 z m 0.23281,1.50268 h 0.99237 v 0.43739 h -0.99237 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.46179,160.29503 h 0.40917 l 1.0159,3.41923 h -0.49854 l -0.72195,-2.73726 -0.72429,2.73726 h -0.49619 z m -0.47503,2.23402 h 1.3898 v 0.4374 h -1.3898 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.88132,162.04227 h 1.12642 v 0.45386 h -1.12642 z m -2.45977,-1.74724 h 0.41388 l 1.28868,2.63144 -0.0658,0.0611 v -2.69259 h 0.44916 v 3.41688 h -0.41623 l -1.28398,-2.5703 0.0635,-0.0611 v 2.63144 h -0.44915 z m 3.02416,1.48151 q -0.27044,0 -0.41859,-0.14815 -0.1458,-0.14815 -0.1458,-0.41388 v -0.38802 q 0,-0.26102 0.1458,-0.40447 0.14815,-0.14345 0.41859,-0.14345 0.27043,0 0.41623,0.1458 0.1458,0.14345 0.1458,0.40448 v 0.38566 q 0,0.26573 -0.1458,0.41388 -0.1458,0.14815 -0.41623,0.14815 z m -0.002,-0.35979 q 0.0894,0 0.13639,-0.0564 0.047,-0.0564 0.047,-0.15756 v -0.37155 q 0,-0.0917 -0.047,-0.1411 -0.047,-0.0517 -0.13639,-0.0517 -0.087,0 -0.13404,0.0517 -0.0447,0.0517 -0.0447,0.1458 v 0.36685 q 0,0.10347 0.0447,0.15991 0.047,0.0541 0.13404,0.0541 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.28186,163.74954 q -0.41859,0 -0.64199,-0.22811 -0.2234,-0.23046 -0.2234,-0.64434 v -1.74724 q 0,-0.41623 0.2234,-0.64434 0.2234,-0.2281 0.64199,-0.2281 0.42094,0 0.64199,0.2281 0.2234,0.22811 0.2234,0.64434 v 1.74724 q 0,0.41388 -0.2234,0.64434 -0.22341,0.22811 -0.64199,0.22811 z m 0,-0.43975 q 0.19989,0 0.301,-0.11288 0.10347,-0.11288 0.10347,-0.31982 v -1.74724 q 0,-0.20929 -0.10111,-0.32217 -0.10112,-0.11288 -0.30336,-0.11288 -0.19989,0 -0.30101,0.11288 -0.10111,0.11288 -0.10111,0.32217 v 1.74724 q 0,0.20694 0.10111,0.31982 0.10112,0.11288 0.30101,0.11288 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.50367,163.74954 q -0.41858,0 -0.64198,-0.22811 -0.22341,-0.23046 -0.22341,-0.64434 v -1.74724 q 0,-0.41623 0.22341,-0.64434 0.2234,-0.2281 0.64198,-0.2281 0.42094,0 0.64199,0.2281 0.2234,0.22811 0.2234,0.64434 v 1.74724 q 0,0.41388 -0.2234,0.64434 -0.2234,0.22811 -0.64199,0.22811 z m 0,-0.43975 q 0.19989,0 0.30101,-0.11288 0.10347,-0.11288 0.10347,-0.31982 v -1.74724 q 0,-0.20929 -0.10112,-0.32217 -0.10112,-0.11288 -0.30336,-0.11288 -0.19988,0 -0.301,0.11288 -0.10112,0.11288 -0.10112,0.32217 v 1.74724 q 0,0.20694 0.10112,0.31982 0.10112,0.11288 0.301,0.11288 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 122.86715,160.29503 h 0.46327 v 1.19932 h -0.46327 z m 0.69373,0 h 0.46326 v 1.19932 h -0.46326 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "4.81608px",
      lineHeight: 1.15,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      letterSpacing: "0.00190108px",
      baselineShift: "baseline",
      textAnchor: "middle"
    },
    id: "path13741"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": " \\u0422\\u0435\\u043B.: 8-012-345-67-89; 8-012-345-67-89 \\u2116__________________\\u043E\\u0442______________________ \\u043D\\u0430 \\u2116_______________\\u043E\\u0442______________________",
    id: "text618433-5-1",
    style: {
      fontSize: "4.4177px",
      lineHeight: 0,
      display: "inline",
      fill: "#074e9c",
      strokeWidth: 0.184071
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 59.388056,169.06249 h 0.424945 v 2.8797 h -0.424945 z m -0.716151,-0.2567 h 1.855089 v 0.40338 h -1.855089 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 61.329428,171.97454 q -0.261007,0 -0.446516,-0.10138 -0.185509,-0.10138 -0.282577,-0.29552 -0.09707,-0.19413 -0.09707,-0.47024 v -0.52849 q 0,-0.28689 0.09491,-0.49181 0.09491,-0.20492 0.271792,-0.31062 0.179038,-0.10785 0.433573,-0.10785 0.24375,0 0.416316,0.11216 0.174724,0.11002 0.265321,0.32141 0.09275,0.21139 0.09275,0.51123 v 0.37749 h -1.272678 v -0.34729 h 0.86499 v -0.12511 q 0,-0.22003 -0.09923,-0.34298 -0.09923,-0.12511 -0.267478,-0.12511 -0.187666,0 -0.291206,0.13158 -0.10354,0.13158 -0.10354,0.37318 v 0.56299 q 0,0.21571 0.110011,0.33651 0.110011,0.11864 0.31062,0.11864 0.131582,0 0.215708,-0.0604 0.08628,-0.0604 0.118639,-0.17472 v 0 l 0.388275,0.11648 v 0 q -0.05824,0.25885 -0.241593,0.39043 -0.181195,0.12942 -0.481029,0.12942 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 62.334627,171.5647 q 0.133739,0 0.202766,-0.1057 0.07118,-0.10569 0.07118,-0.30415 v -1.45171 h 0.424945 v 1.50133 q 0,0.2459 -0.0755,0.41416 -0.07334,0.16825 -0.220022,0.25669 -0.146681,0.0863 -0.360232,0.0863 h -0.04314 z m 1.246793,-1.86156 h 0.424944 v 2.23905 H 63.58142 Z m -0.698894,0 h 0.916759 v 0.40337 h -0.916759 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 64.506807,171.49567 h 0.446515 v 0.44652 h -0.446515 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 65.37611,171.49567 h 0.446516 v 0.44652 H 65.37611 Z m 0,-1.799 h 0.446516 v 0.44651 H 65.37611 Z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 68.132859,171.97454 q -0.252379,0 -0.437888,-0.0927 -0.183351,-0.0927 -0.284734,-0.26748 -0.09923,-0.17472 -0.09923,-0.40984 v -0.28689 q 0,-0.20277 0.101383,-0.37102 0.101383,-0.17041 0.278263,-0.26101 -0.150995,-0.0777 -0.239436,-0.21786 -0.08628,-0.14237 -0.08628,-0.30415 v -0.25669 q 0,-0.22434 0.09276,-0.38828 0.09275,-0.16609 0.26532,-0.25453 0.174724,-0.0906 0.409846,-0.0906 0.237278,0 0.409845,0.0906 0.172566,0.0884 0.265321,0.25453 0.09491,0.16394 0.09491,0.38828 v 0.25669 q 0,0.16609 -0.0906,0.3063 -0.08844,0.14021 -0.241593,0.21571 0.179037,0.0906 0.282577,0.26101 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.101383,0.40984 -0.09923,0.17473 -0.284734,0.26748 -0.185509,0.0927 -0.437887,0.0927 z m 0,-0.40984 q 0.122953,0 0.211393,-0.0475 0.0906,-0.0474 0.138054,-0.13373 0.04961,-0.0884 0.04961,-0.20493 v -0.2912 q 0,-0.11217 -0.04961,-0.19414 -0.04746,-0.0841 -0.138054,-0.12727 -0.08844,-0.0453 -0.211393,-0.0453 -0.120797,0 -0.211394,0.0453 -0.0906,0.0453 -0.14021,0.12943 -0.04746,0.082 -0.04746,0.19413 v 0.29337 q 0,0.11648 0.04746,0.20276 0.04961,0.0863 0.14021,0.13374 0.0906,0.0453 0.211394,0.0453 z m 0,-1.44956 q 0.105696,0 0.183351,-0.0431 0.07766,-0.0453 0.11864,-0.12942 0.04314,-0.0841 0.04314,-0.19846 v -0.18982 q 0,-0.11217 -0.04314,-0.19629 -0.04098,-0.0841 -0.11864,-0.12943 -0.07765,-0.0453 -0.183351,-0.0453 -0.10354,0 -0.181195,0.0453 -0.07765,0.0453 -0.120797,0.12943 -0.04098,0.0841 -0.04098,0.19845 v 0.19198 q 0,0.11217 0.04098,0.19629 0.04314,0.082 0.120797,0.12727 0.07766,0.0431 0.181195,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.762339,170.61774 v 0.40122 h -1.270521 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 72.101886,171.97454 q -0.383961,0 -0.588883,-0.20923 -0.204923,-0.2114 -0.204923,-0.59104 v -1.60271 q 0,-0.38181 0.204923,-0.59104 0.204922,-0.20924 0.588883,-0.20924 0.386117,0 0.588882,0.20924 0.204923,0.20923 0.204923,0.59104 v 1.60271 q 0,0.37964 -0.204923,0.59104 -0.204922,0.20923 -0.588882,0.20923 z m 0,-0.40337 q 0.183351,0 0.276106,-0.10354 0.09491,-0.10354 0.09491,-0.29336 v -1.60271 q 0,-0.19198 -0.09275,-0.29552 -0.09275,-0.10354 -0.278263,-0.10354 -0.183352,0 -0.276107,0.10354 -0.09275,0.10354 -0.09275,0.29552 v 1.60271 q 0,0.18982 0.09275,0.29336 0.09275,0.10354 0.276107,0.10354 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.187781,171.94219 h -0.424944 v -2.68557 l -0.461616,0.28474 v -0.44005 l 0.442202,-0.29552 h 0.444358 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.716266,171.57549 0.890874,-1.34818 q 0.11864,-0.18982 0.181195,-0.36023 0.06256,-0.17257 0.06256,-0.30846 v -0.006 q 0,-0.17903 -0.08844,-0.27395 -0.08628,-0.0971 -0.252378,-0.0971 -0.174724,0 -0.273949,0.12079 -0.09707,0.11864 -0.110011,0.34298 v 0.006 h -0.437888 v -0.006 q 0.01941,-0.28042 0.11864,-0.47456 0.09922,-0.19629 0.271792,-0.29552 0.174723,-0.10138 0.416316,-0.10138 0.256693,0 0.433573,0.0906 0.176881,0.0906 0.267478,0.26532 0.09275,0.17472 0.09275,0.4271 v 0.004 q 0,0.17688 -0.07334,0.38828 -0.07118,0.20923 -0.20708,0.43141 l -0.744192,1.15835 h 1.031084 v 0.40338 h -1.578983 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.059741,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.325946,171.97454 q -0.267478,0 -0.448672,-0.0927 -0.179038,-0.0927 -0.27395,-0.28258 -0.09275,-0.19198 -0.105696,-0.48318 v 0 h 0.429258 v 0 q 0.0065,0.15746 0.05393,0.25669 0.04746,0.0971 0.131582,0.14452 0.08628,0.0475 0.213551,0.0475 0.179038,0 0.276106,-0.0971 0.09923,-0.0992 0.09923,-0.27395 v -0.27179 q 0,-0.19414 -0.0906,-0.30199 -0.0906,-0.10786 -0.252379,-0.10786 H 79.13828 v -0.40121 h 0.220022 q 0.138054,0 0.213551,-0.0884 0.07765,-0.0906 0.07765,-0.25022 v -0.2718 q 0,-0.15099 -0.08413,-0.23296 -0.08413,-0.0841 -0.241593,-0.0841 -0.107854,0 -0.181195,0.0475 -0.07118,0.0474 -0.114325,0.14668 -0.04098,0.0992 -0.05177,0.25454 v 0 h -0.427102 v 0 q 0.0151,-0.29121 0.105697,-0.48103 0.09275,-0.19198 0.261007,-0.28474 0.168252,-0.0927 0.420631,-0.0927 0.351604,0 0.543584,0.19198 0.194137,0.18982 0.194137,0.53495 v 0.25454 q 0,0.17041 -0.09923,0.31493 -0.09707,0.14453 -0.276106,0.23513 0.202766,0.0604 0.314934,0.22649 0.112168,0.16609 0.112168,0.412 v 0.25669 q 0,0.24375 -0.09491,0.41848 -0.09275,0.17472 -0.273949,0.26532 -0.179037,0.0906 -0.431416,0.0906 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.596466,171.09014 0.860675,-2.28219 h 0.437887 l -0.83479,2.25631 h 1.350332 v 0.3969 h -1.814104 z m 1.162666,-0.98794 h 0.418474 v 1.84215 h -0.418474 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.612064,171.97454 q -0.239436,0 -0.407688,-0.0906 -0.168252,-0.0906 -0.261006,-0.26964 -0.09275,-0.17904 -0.105697,-0.4422 v 0 h 0.424944 v 0 q 0.0086,0.1963 0.09707,0.29768 0.08844,0.0992 0.252378,0.0992 0.17041,0 0.263164,-0.10785 0.09491,-0.10785 0.09491,-0.30199 v -0.55221 q 0,-0.19414 -0.0906,-0.30199 -0.0906,-0.10786 -0.256692,-0.10786 -0.11864,0 -0.204923,0.069 -0.08628,0.069 -0.125111,0.19413 h -0.386117 v -1.65448 h 1.430144 v 0.40338 h -1.005199 v 0.72909 q 0.07118,-0.069 0.166095,-0.10785 0.09491,-0.0388 0.194137,-0.0388 0.222179,0 0.379646,0.0971 0.157467,0.0949 0.239436,0.27826 0.08197,0.1812 0.08197,0.44005 v 0.55221 q 0,0.25669 -0.09275,0.44004 -0.0906,0.18335 -0.265321,0.28042 -0.174724,0.0949 -0.422788,0.0949 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 86.219973,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 87.484022,171.97454 q -0.248065,0 -0.424945,-0.0992 -0.174724,-0.10138 -0.267478,-0.29121 -0.0906,-0.18982 -0.0906,-0.45945 v -0.2114 q 0,-0.18119 0.04098,-0.34513 0.04099,-0.1661 0.122954,-0.36023 0.01294,-0.0281 0.02589,-0.0561 0.01294,-0.0302 0.02588,-0.0582 l 0.59104,-1.28778 h 0.459458 l -0.731251,1.56389 -0.05393,-0.0777 q 0.06687,-0.10138 0.17041,-0.15746 0.10354,-0.0561 0.226493,-0.0561 0.217865,0 0.373175,0.0949 0.157467,0.0928 0.237279,0.27395 0.08197,0.17904 0.08197,0.43358 v 0.23512 q 0,0.26963 -0.09275,0.46377 -0.09275,0.19198 -0.269635,0.29336 -0.17688,0.10138 -0.424944,0.10138 z m 0,-0.40984 q 0.174723,0 0.267478,-0.11001 0.09491,-0.11001 0.09491,-0.30846 v -0.22434 q 0,-0.20708 -0.09707,-0.32141 -0.09707,-0.11432 -0.27395,-0.11432 -0.166095,0 -0.258849,0.11648 -0.0906,0.11433 -0.0906,0.32141 v 0.22433 q 0,0.19845 0.09275,0.30847 0.09491,0.10785 0.265321,0.10785 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 90.193314,169.18544 -0.750664,2.75675 h -0.446515 l 0.754978,-2.73302 h -0.670852 v 0.412 h -0.424945 v -0.81538 h 1.537998 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 91.977219,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 93.323239,171.97454 q -0.252379,0 -0.437888,-0.0927 -0.183351,-0.0927 -0.284734,-0.26748 -0.09923,-0.17472 -0.09923,-0.40984 v -0.28689 q 0,-0.20277 0.101383,-0.37102 0.101383,-0.17041 0.278263,-0.26101 -0.150995,-0.0777 -0.239436,-0.21786 -0.08628,-0.14237 -0.08628,-0.30415 v -0.25669 q 0,-0.22434 0.09275,-0.38828 0.09275,-0.16609 0.26532,-0.25453 0.174724,-0.0906 0.409846,-0.0906 0.237278,0 0.409845,0.0906 0.172566,0.0884 0.265321,0.25453 0.09491,0.16394 0.09491,0.38828 v 0.25669 q 0,0.16609 -0.0906,0.3063 -0.08844,0.14021 -0.241593,0.21571 0.179038,0.0906 0.282577,0.26101 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.101383,0.40984 -0.09923,0.17473 -0.284734,0.26748 -0.185509,0.0927 -0.437887,0.0927 z m 0,-0.40984 q 0.122953,0 0.211393,-0.0475 0.0906,-0.0474 0.138054,-0.13373 0.04961,-0.0884 0.04961,-0.20493 v -0.2912 q 0,-0.11217 -0.04961,-0.19414 -0.04746,-0.0841 -0.138054,-0.12727 -0.08844,-0.0453 -0.211393,-0.0453 -0.120797,0 -0.211394,0.0453 -0.0906,0.0453 -0.14021,0.12943 -0.04746,0.082 -0.04746,0.19413 v 0.29337 q 0,0.11648 0.04746,0.20276 0.04961,0.0863 0.14021,0.13374 0.0906,0.0453 0.211394,0.0453 z m 0,-1.44956 q 0.105697,0 0.183351,-0.0431 0.07765,-0.0453 0.11864,-0.12942 0.04314,-0.0841 0.04314,-0.19846 v -0.18982 q 0,-0.11217 -0.04314,-0.19629 -0.04099,-0.0841 -0.11864,-0.12943 -0.07765,-0.0453 -0.183351,-0.0453 -0.10354,0 -0.181195,0.0453 -0.07765,0.0453 -0.120797,0.12943 -0.04098,0.0841 -0.04098,0.19845 v 0.19198 q 0,0.11217 0.04098,0.19629 0.04314,0.082 0.120797,0.12727 0.07766,0.0431 0.181195,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 95.631313,170.38046 0.05177,0.0777 q -0.06256,0.10138 -0.168253,0.15315 -0.103539,0.0518 -0.22865,0.0518 -0.211394,0 -0.366704,-0.0971 -0.155309,-0.0971 -0.239436,-0.2761 -0.08413,-0.17904 -0.08413,-0.42064 v -0.23512 q 0,-0.27179 0.09276,-0.46377 0.09275,-0.19414 0.267478,-0.29552 0.17688,-0.10138 0.424944,-0.10138 0.248065,0 0.424945,0.10138 0.176881,0.10138 0.267478,0.29552 0.09275,0.19198 0.09275,0.46377 v 0.2114 q 0,0.17688 -0.04314,0.34297 -0.04098,0.16394 -0.125111,0.35808 -0.01079,0.028 -0.02373,0.0561 -0.01294,0.028 -0.02588,0.0561 l -0.584569,1.28346 h -0.457301 z m -0.250222,-0.11864 q 0.172567,0 0.265321,-0.11216 0.09491,-0.11217 0.09491,-0.31278 v -0.22649 q 0,-0.20277 -0.09491,-0.31494 -0.09275,-0.11217 -0.265321,-0.11217 -0.172566,0 -0.267477,0.11217 -0.09275,0.11217 -0.09275,0.31709 v 0.2265 q 0,0.2006 0.09275,0.31277 0.09491,0.11001 0.267477,0.11001 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96.58043,171.49567 h 0.446516 v 0.67733 l -0.446516,0.48103 z m 0,-1.799 h 0.446516 v 0.44651 H 96.58043 Z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.337178,171.97454 q -0.252379,0 -0.437888,-0.0927 -0.183351,-0.0927 -0.284734,-0.26748 -0.09923,-0.17472 -0.09923,-0.40984 v -0.28689 q 0,-0.20277 0.101383,-0.37102 0.101383,-0.17041 0.278263,-0.26101 -0.150995,-0.0777 -0.239436,-0.21786 -0.08628,-0.14237 -0.08628,-0.30415 v -0.25669 q 0,-0.22434 0.09276,-0.38828 0.09275,-0.16609 0.26532,-0.25453 0.174724,-0.0906 0.409846,-0.0906 0.237278,0 0.409845,0.0906 0.172566,0.0884 0.265317,0.25453 0.0949,0.16394 0.0949,0.38828 v 0.25669 q 0,0.16609 -0.0906,0.3063 -0.08844,0.14021 -0.241595,0.21571 0.179037,0.0906 0.282575,0.26101 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.10138,0.40984 -0.09923,0.17473 -0.284735,0.26748 -0.185509,0.0927 -0.437887,0.0927 z m 0,-0.40984 q 0.122953,0 0.211393,-0.0475 0.0906,-0.0474 0.138054,-0.13373 0.04961,-0.0884 0.04961,-0.20493 v -0.2912 q 0,-0.11217 -0.04961,-0.19414 -0.04746,-0.0841 -0.138054,-0.12727 -0.08844,-0.0453 -0.211393,-0.0453 -0.120797,0 -0.211394,0.0453 -0.0906,0.0453 -0.14021,0.12943 -0.04746,0.082 -0.04746,0.19413 v 0.29337 q 0,0.11648 0.04746,0.20276 0.04961,0.0863 0.14021,0.13374 0.0906,0.0453 0.211394,0.0453 z m 0,-1.44956 q 0.105696,0 0.183351,-0.0431 0.07766,-0.0453 0.11864,-0.12942 0.04314,-0.0841 0.04314,-0.19846 v -0.18982 q 0,-0.11217 -0.04314,-0.19629 -0.04098,-0.0841 -0.11864,-0.12943 -0.07765,-0.0453 -0.183351,-0.0453 -0.10354,0 -0.181195,0.0453 -0.07766,0.0453 -0.120797,0.12943 -0.04098,0.0841 -0.04098,0.19845 v 0.19198 q 0,0.11217 0.04098,0.19629 0.04314,0.082 0.120797,0.12727 0.07765,0.0431 0.181195,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 101.96666,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.3062,171.97454 q -0.38396,0 -0.58888,-0.20923 -0.20492,-0.2114 -0.20492,-0.59104 v -1.60271 q 0,-0.38181 0.20492,-0.59104 0.20492,-0.20924 0.58888,-0.20924 0.38612,0 0.58889,0.20924 0.20492,0.20923 0.20492,0.59104 v 1.60271 q 0,0.37964 -0.20492,0.59104 -0.20493,0.20923 -0.58889,0.20923 z m 0,-0.40337 q 0.18336,0 0.27611,-0.10354 0.0949,-0.10354 0.0949,-0.29336 v -1.60271 q 0,-0.19198 -0.0928,-0.29552 -0.0928,-0.10354 -0.27827,-0.10354 -0.18335,0 -0.2761,0.10354 -0.0928,0.10354 -0.0928,0.29552 v 1.60271 q 0,0.18982 0.0928,0.29336 0.0927,0.10354 0.2761,0.10354 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.3921,171.94219 h -0.42494 v -2.68557 l -0.46162,0.28474 v -0.44005 l 0.4422,-0.29552 h 0.44436 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13810"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.92058,171.57549 0.89088,-1.34818 q 0.11864,-0.18982 0.18119,-0.36023 0.0626,-0.17257 0.0626,-0.30846 v -0.006 q 0,-0.17903 -0.0884,-0.27395 -0.0863,-0.0971 -0.25238,-0.0971 -0.17472,0 -0.27395,0.12079 -0.0971,0.11864 -0.11001,0.34298 v 0.006 h -0.43789 v -0.006 q 0.0194,-0.28042 0.11864,-0.47456 0.0992,-0.19629 0.27179,-0.29552 0.17473,-0.10138 0.41632,-0.10138 0.25669,0 0.43357,0.0906 0.17688,0.0906 0.26748,0.26532 0.0927,0.17472 0.0927,0.4271 v 0.004 q 0,0.17688 -0.0733,0.38828 -0.0712,0.20923 -0.20708,0.43141 l -0.74419,1.15835 h 1.03109 v 0.40338 h -1.57899 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13812"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.26406,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.53027,171.97454 q -0.26748,0 -0.44868,-0.0927 -0.17904,-0.0927 -0.27395,-0.28258 -0.0928,-0.19198 -0.10569,-0.48318 v 0 h 0.42926 v 0 q 0.006,0.15746 0.0539,0.25669 0.0475,0.0971 0.13158,0.14452 0.0863,0.0475 0.21356,0.0475 0.17903,0 0.2761,-0.0971 0.0992,-0.0992 0.0992,-0.27395 v -0.27179 q 0,-0.19414 -0.0906,-0.30199 -0.0906,-0.10786 -0.25238,-0.10786 h -0.22002 v -0.40121 h 0.22002 q 0.13805,0 0.21355,-0.0884 0.0777,-0.0906 0.0777,-0.25022 v -0.2718 q 0,-0.15099 -0.0841,-0.23296 -0.0841,-0.0841 -0.24159,-0.0841 -0.10786,0 -0.1812,0.0475 -0.0712,0.0474 -0.11432,0.14668 -0.041,0.0992 -0.0518,0.25454 v 0 h -0.4271 v 0 q 0.0151,-0.29121 0.10569,-0.48103 0.0928,-0.19198 0.26101,-0.28474 0.16825,-0.0927 0.42063,-0.0927 0.3516,0 0.54358,0.19198 0.19414,0.18982 0.19414,0.53495 v 0.25454 q 0,0.17041 -0.0992,0.31493 -0.0971,0.14453 -0.27611,0.23513 0.20277,0.0604 0.31493,0.22649 0.11217,0.16609 0.11217,0.412 v 0.25669 q 0,0.24375 -0.0949,0.41848 -0.0927,0.17472 -0.27395,0.26532 -0.17904,0.0906 -0.43141,0.0906 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.80079,171.09014 0.86067,-2.28219 h 0.43789 l -0.83479,2.25631 h 1.35033 v 0.3969 h -1.8141 z m 1.16266,-0.98794 h 0.41847 v 1.84215 h -0.41847 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.81638,171.97454 q -0.23943,0 -0.40769,-0.0906 -0.16825,-0.0906 -0.261,-0.26964 -0.0928,-0.17904 -0.1057,-0.4422 v 0 h 0.42494 v 0 q 0.009,0.1963 0.0971,0.29768 0.0884,0.0992 0.25238,0.0992 0.17041,0 0.26317,-0.10785 0.0949,-0.10785 0.0949,-0.30199 v -0.55221 q 0,-0.19414 -0.0906,-0.30199 -0.0906,-0.10786 -0.25669,-0.10786 -0.11864,0 -0.20493,0.069 -0.0863,0.069 -0.12511,0.19413 h -0.38611 v -1.65448 h 1.43014 v 0.40338 h -1.0052 v 0.72909 q 0.0712,-0.069 0.1661,-0.10785 0.0949,-0.0388 0.19413,-0.0388 0.22218,0 0.37965,0.0971 0.15747,0.0949 0.23944,0.27826 0.082,0.1812 0.082,0.44005 v 0.55221 q 0,0.25669 -0.0927,0.44004 -0.0906,0.18335 -0.26532,0.28042 -0.17472,0.0949 -0.42279,0.0949 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.42429,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13822"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.68834,171.97454 q -0.24806,0 -0.42494,-0.0992 -0.17473,-0.10138 -0.26748,-0.29121 -0.0906,-0.18982 -0.0906,-0.45945 v -0.2114 q 0,-0.18119 0.041,-0.34513 0.041,-0.1661 0.12295,-0.36023 0.0129,-0.0281 0.0259,-0.0561 0.013,-0.0302 0.0259,-0.0582 l 0.59104,-1.28778 h 0.45946 l -0.73125,1.56389 -0.0539,-0.0777 q 0.0669,-0.10138 0.17041,-0.15746 0.10354,-0.0561 0.22649,-0.0561 0.21787,0 0.37318,0.0949 0.15746,0.0928 0.23728,0.27395 0.082,0.17904 0.082,0.43358 v 0.23512 q 0,0.26963 -0.0927,0.46377 -0.0927,0.19198 -0.26963,0.29336 -0.17689,0.10138 -0.42495,0.10138 z m 0,-0.40984 q 0.17472,0 0.26748,-0.11001 0.0949,-0.11001 0.0949,-0.30846 v -0.22434 q 0,-0.20708 -0.0971,-0.32141 -0.0971,-0.11432 -0.27395,-0.11432 -0.16609,0 -0.25885,0.11648 -0.0906,0.11433 -0.0906,0.32141 v 0.22433 q 0,0.19845 0.0927,0.30847 0.0949,0.10785 0.26532,0.10785 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.39764,169.18544 -0.75067,2.75675 h -0.44651 l 0.75497,-2.73302 h -0.67085 v 0.412 h -0.42494 v -0.81538 h 1.538 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 123.18154,170.61774 v 0.40122 h -1.27052 v -0.40122 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.52756,171.97454 q -0.25238,0 -0.43789,-0.0927 -0.18335,-0.0927 -0.28473,-0.26748 -0.0992,-0.17472 -0.0992,-0.40984 v -0.28689 q 0,-0.20277 0.10138,-0.37102 0.10139,-0.17041 0.27827,-0.26101 -0.151,-0.0777 -0.23944,-0.21786 -0.0863,-0.14237 -0.0863,-0.30415 v -0.25669 q 0,-0.22434 0.0927,-0.38828 0.0928,-0.16609 0.26532,-0.25453 0.17473,-0.0906 0.40985,-0.0906 0.23728,0 0.40984,0.0906 0.17257,0.0884 0.26532,0.25453 0.0949,0.16394 0.0949,0.38828 v 0.25669 q 0,0.16609 -0.0906,0.3063 -0.0884,0.14021 -0.2416,0.21571 0.17904,0.0906 0.28258,0.26101 0.10354,0.16825 0.10354,0.37102 v 0.28689 q 0,0.23512 -0.10138,0.40984 -0.0992,0.17473 -0.28474,0.26748 -0.1855,0.0927 -0.43788,0.0927 z m 0,-0.40984 q 0.12295,0 0.21139,-0.0475 0.0906,-0.0474 0.13805,-0.13373 0.0496,-0.0884 0.0496,-0.20493 v -0.2912 q 0,-0.11217 -0.0496,-0.19414 -0.0474,-0.0841 -0.13805,-0.12727 -0.0884,-0.0453 -0.21139,-0.0453 -0.1208,0 -0.2114,0.0453 -0.0906,0.0453 -0.14021,0.12943 -0.0474,0.082 -0.0474,0.19413 v 0.29337 q 0,0.11648 0.0474,0.20276 0.0496,0.0863 0.14021,0.13374 0.0906,0.0453 0.2114,0.0453 z m 0,-1.44956 q 0.10569,0 0.18335,-0.0431 0.0777,-0.0453 0.11864,-0.12942 0.0431,-0.0841 0.0431,-0.19846 v -0.18982 q 0,-0.11217 -0.0431,-0.19629 -0.041,-0.0841 -0.11864,-0.12943 -0.0777,-0.0453 -0.18335,-0.0453 -0.10354,0 -0.1812,0.0453 -0.0777,0.0453 -0.12079,0.12943 -0.041,0.0841 -0.041,0.19845 v 0.19198 q 0,0.11217 0.041,0.19629 0.0431,0.082 0.12079,0.12727 0.0777,0.0431 0.1812,0.0431 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.83563,170.38046 0.0518,0.0777 q -0.0626,0.10138 -0.16825,0.15315 -0.10354,0.0518 -0.22865,0.0518 -0.21139,0 -0.3667,-0.0971 -0.15531,-0.0971 -0.23944,-0.2761 -0.0841,-0.17904 -0.0841,-0.42064 v -0.23512 q 0,-0.27179 0.0928,-0.46377 0.0928,-0.19414 0.26748,-0.29552 0.17688,-0.10138 0.42494,-0.10138 0.24806,0 0.42495,0.10138 0.17688,0.10138 0.26747,0.29552 0.0928,0.19198 0.0928,0.46377 v 0.2114 q 0,0.17688 -0.0431,0.34297 -0.041,0.16394 -0.12511,0.35808 -0.0108,0.028 -0.0237,0.0561 -0.013,0.028 -0.0259,0.0561 l -0.58457,1.28346 h -0.4573 z m -0.25022,-0.11864 q 0.17257,0 0.26532,-0.11216 0.0949,-0.11217 0.0949,-0.31278 v -0.22649 q 0,-0.20277 -0.0949,-0.31494 -0.0927,-0.11217 -0.26532,-0.11217 -0.17257,0 -0.26748,0.11217 -0.0928,0.11217 -0.0928,0.31709 v 0.2265 q 0,0.2006 0.0928,0.31277 0.0949,0.11001 0.26748,0.11001 z",
    style: {
      fontStretch: "semi-condensed",
      lineHeight: 1.05,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 62.531673,179.55227 h 0.918436 v 0.37006 h -0.918436 z m -2.005603,-1.42463 h 0.337463 l 1.050737,2.14557 -0.05369,0.0498 v -2.19542 h 0.366224 v 2.78598 h -0.33938 l -1.046902,-2.09572 0.05177,-0.0499 v 2.14557 H 60.52607 Z m 2.46578,1.20796 q -0.220501,0 -0.341298,-0.12079 -0.118879,-0.1208 -0.118879,-0.33747 v -0.31637 q 0,-0.21283 0.118879,-0.32979 0.120797,-0.11696 0.341298,-0.11696 0.220501,0 0.33938,0.11888 0.118879,0.11696 0.118879,0.32979 v 0.31445 q 0,0.21667 -0.118879,0.33747 -0.118879,0.12079 -0.33938,0.12079 z m -0.0019,-0.29336 q 0.07286,0 0.11121,-0.046 0.03835,-0.046 0.03835,-0.12846 v -0.30295 q 0,-0.0748 -0.03835,-0.11505 -0.03835,-0.0422 -0.11121,-0.0422 -0.07094,0 -0.109291,0.0422 -0.03643,0.0422 -0.03643,0.11888 v 0.29912 q 0,0.0844 0.03643,0.13038 0.03835,0.0441 0.109291,0.0441 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 64.987866,180.92513 v 0.35664 H 63.58241 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 66.4681,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 67.948335,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 69.42857,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.908804,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 72.389038,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.869273,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.349508,180.92513 v 0.35664 h -1.405455 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.829743,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.309977,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.790211,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.270447,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.750681,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 84.230915,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 85.711151,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 87.191385,180.92513 v 0.35664 H 85.78593 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 88.67162,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 90.151854,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 91.09138,180.9443 q -0.218583,0 -0.373893,-0.0844 -0.15531,-0.0844 -0.237758,-0.24351 -0.08245,-0.16106 -0.08245,-0.38732 v -0.62891 q 0,-0.22433 0.08245,-0.38156 0.08245,-0.15914 0.237758,-0.24159 0.15531,-0.0844 0.373893,-0.0844 0.216667,0 0.371976,0.0844 0.15531,0.0825 0.235841,0.24159 0.08053,0.15723 0.08053,0.38156 v 0.63466 q 0,0.22434 -0.08053,0.38348 -0.08053,0.15915 -0.235841,0.24351 -0.155309,0.0824 -0.371976,0.0824 z m -0.0019,-0.36239 q 0.14764,0 0.230088,-0.092 0.08245,-0.094 0.08245,-0.2646 v -0.61741 q 0,-0.16681 -0.08245,-0.25885 -0.08245,-0.092 -0.230088,-0.092 -0.149557,0 -0.232006,0.092 -0.08245,0.092 -0.08245,0.25885 v 0.61741 q 0,0.16873 0.08245,0.26268 0.08245,0.094 0.232006,0.094 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.448902,179.02498 h 0.377728 v 1.89056 h -0.377728 z m -0.462094,-0.0997 h 1.301916 v 0.34897 h -1.301916 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.884003,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96.364239,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 97.844471,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.324707,180.92513 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 100.80494,180.92513 v 0.35664 h -1.405453 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 102.28518,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.76541,180.92513 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.24564,180.92513 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.72588,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.20612,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.68635,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.16658,180.92513 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.64682,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.12705,180.92513 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.60729,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.08752,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13906"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.56776,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.04799,180.92513 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.52823,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 123.00846,180.92513 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.4887,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.96893,180.92513 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 61.423415,183.2448 h 0.375811 v 1.99027 h -0.375811 z m -1.010471,0 h 0.377728 v 1.99027 h -0.377728 z m 0.230088,0.83791 h 0.997049 v 0.34896 h -0.997049 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 63.281378,183.87179 q 0,-0.15531 -0.08437,-0.24159 -0.08245,-0.0863 -0.233923,-0.0863 -0.111209,0 -0.195575,0.0518 -0.08437,0.0518 -0.126549,0.14572 l -0.320206,-0.094 q 0.05369,-0.20708 0.220501,-0.32021 0.168732,-0.11504 0.419911,-0.11504 0.216667,0 0.370059,0.0786 0.153392,0.0767 0.232006,0.22242 0.08053,0.14572 0.08053,0.35088 v 1.37095 h -0.362389 z m -0.421829,1.39204 q -0.304867,0 -0.456342,-0.14573 -0.151474,-0.14572 -0.151474,-0.43908 0,-0.31637 0.159144,-0.4736 0.161062,-0.15723 0.483185,-0.15723 h 0.404572 l 0.02684,0.32021 H 62.89598 q -0.143805,0 -0.214749,0.0767 -0.07094,0.0767 -0.07094,0.23392 0,0.1323 0.07861,0.19749 0.07861,0.0652 0.237758,0.0652 0.178319,0 0.266519,-0.0614 0.0882,-0.0633 0.0882,-0.19174 l 0.04027,0.23008 q -0.02684,0.11697 -0.08628,0.19366 -0.05944,0.0767 -0.153392,0.11505 -0.09395,0.0364 -0.222419,0.0364 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 67.077834,183.87179 h 0.918436 v 0.37006 h -0.918436 z m -2.005603,-1.42463 h 0.337463 l 1.050737,2.14558 -0.05369,0.0499 v -2.19543 h 0.366224 v 2.78599 h -0.33938 l -1.046902,-2.09572 0.05177,-0.0498 v 2.14557 h -0.366224 z m 2.46578,1.20797 q -0.220502,0 -0.341298,-0.1208 -0.118879,-0.1208 -0.118879,-0.33746 v -0.31637 q 0,-0.21284 0.118879,-0.3298 0.120796,-0.11696 0.341298,-0.11696 0.220501,0 0.33938,0.11888 0.118879,0.11696 0.118879,0.32979 v 0.31446 q 0,0.21666 -0.118879,0.33746 -0.118879,0.1208 -0.33938,0.1208 z m -0.0019,-0.29337 q 0.07286,0 0.11121,-0.046 0.03835,-0.046 0.03835,-0.12847 v -0.30295 q 0,-0.0748 -0.03835,-0.11504 -0.03835,-0.0422 -0.11121,-0.0422 -0.07094,0 -0.109292,0.0422 -0.03643,0.0422 -0.03643,0.11888 v 0.29911 q 0,0.0844 0.03643,0.13038 0.03835,0.0441 0.109292,0.0441 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 69.534027,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.014262,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 72.494496,185.24465 v 0.35664 H 71.08904 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.974731,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.454965,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.9352,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 78.415434,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.895668,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.375904,185.24465 v 0.35664 h -1.405455 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 82.856139,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 84.336373,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 85.816607,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 87.296843,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 88.777077,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 90.257311,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 91.196838,185.26383 q -0.218584,0 -0.373894,-0.0844 -0.155309,-0.0844 -0.237757,-0.24351 -0.08245,-0.16106 -0.08245,-0.38731 v -0.62891 q 0,-0.22434 0.08245,-0.38157 0.08245,-0.15914 0.237757,-0.24159 0.15531,-0.0844 0.373894,-0.0844 0.216666,0 0.371976,0.0844 0.15531,0.0824 0.23584,0.24159 0.08053,0.15723 0.08053,0.38157 v 0.63466 q 0,0.22433 -0.08053,0.38348 -0.08053,0.15914 -0.23584,0.24351 -0.15531,0.0825 -0.371976,0.0825 z m -0.0019,-0.36239 q 0.147639,0 0.230088,-0.092 0.08245,-0.094 0.08245,-0.2646 v -0.6174 q 0,-0.16682 -0.08245,-0.25885 -0.08245,-0.092 -0.230088,-0.092 -0.149558,0 -0.232006,0.092 -0.08245,0.092 -0.08245,0.25885 v 0.6174 q 0,0.16873 0.08245,0.26269 0.08245,0.094 0.232006,0.094 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 92.554359,183.34451 h 0.377728 v 1.89056 h -0.377728 z m -0.462094,-0.0997 h 1.301916 v 0.34897 h -1.301916 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.98946,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96.469696,185.24465 v 0.35664 H 95.06424 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 97.949929,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.430165,185.24465 v 0.35664 h -1.405456 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 100.9104,185.24465 v 0.35664 h -1.405455 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 102.39063,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.87087,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 105.3511,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.83134,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 108.31157,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 109.79181,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 111.27204,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 112.75227,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 114.23251,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.71275,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 117.19298,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 118.67321,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.15345,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.63368,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 123.11392,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path13998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 124.59415,185.24465 v 0.35664 h -1.40545 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path14000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 126.07439,185.24465 v 0.35664 h -1.40546 v -0.35664 z",
    style: {
      fontStretch: "semi-condensed",
      fontSize: "3.92684px",
      lineHeight: 1.1,
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Semi-Condensed'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path14002"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#074e9c",
      strokeWidth: 0.462641,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 59.170682,174.37024 H 127.29068",
    id: "path59798-7-7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStamp2);
export default __webpack_public_path__ + "static/media/Stamp2.d6aabbc1e358a64ef2fd814b3849f0a7.svg";
export { ForwardRef as ReactComponent };